<main class="d-flex flex-column h-100">
  <ng-ebill-header-container></ng-ebill-header-container>
  <section class="mt-1 flex-grow-1 overflow-auto">
    <router-outlet></router-outlet>
  </section>
</main>
